import { render, staticRenderFns } from "./ModalWithoutStore.vue?vue&type=template&id=fa5af27c&scoped=true&"
import script from "./ModalWithoutStore.vue?vue&type=script&lang=js&"
export * from "./ModalWithoutStore.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithoutStore.vue?vue&type=style&index=0&id=fa5af27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5af27c",
  null
  
)

export default component.exports